import * as React from 'react';
import cx from 'classnames';

import './Label.styles.scss';

export class Label extends React.Component {
    render() {
        const { text, className, ...restProps } = this.props;

        return <div className={cx('Label', className)} {...restProps}>{text || children}</div>;
    }
}